// removed by extract-text-webpack-plugin
module.exports = {"page":"InviteTalent_page__10jA","form":"InviteTalent_form__2Tdz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/KingstonConnect/styles/InviteTalent.scss
// module id = 230
// module chunks = 0